import { css } from 'styled-components';

export const IbmplexsansNormalRiverBed14px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalShark20px = css`
  color: var(--shark);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumPersianIndigo13px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalPersianIndigo13px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumGreenHouse13px = css`
  color: var(--green-house);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumElectricViolet14px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumHorsesNeck13px = css`
  color: var(--horses-neck);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalShark16px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalPersianIndigo20px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalChicago13px = css`
  color: var(--chicago);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalWhite20px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumWhite13px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumRiverBed32px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumElectricViolet16px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansBoldShark36px = css`
  color: var(--dark-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansBoldShark64px = css`
  color: var(--dark-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
`;
